import React, { createContext, useState, useContext, useCallback } from 'react';

// Create the context
export const LogContext = createContext();

// Create a provider component
export const LogProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);

  // Add a new log entry
  const addLog = useCallback((type, message, data = null) => {
    setLogs(prevLogs => [...prevLogs, {
      type, 
      message,
      data,
      timestamp: new Date().getTime()
    }]);
  }, []);

  // Clear all logs
  const clearLogs = useCallback(() => {
    setLogs([]);
  }, []);

  // Helper methods for different log types
  const logInfo = useCallback((message, data) => addLog('info', message, data), [addLog]);
  const logError = useCallback((message, data) => addLog('error', message, data), [addLog]);
  const logWarning = useCallback((message, data) => addLog('warning', message, data), [addLog]);
  const logSuccess = useCallback((message, data) => addLog('success', message, data), [addLog]);
  const logAI = useCallback((message, data) => addLog('ai', message, data), [addLog]);
  const logLayout = useCallback((message, data) => addLog('layout', message, data), [addLog]);
  const logPhotos = useCallback((message, data) => addLog('photos', message, data), [addLog]);

  return (
    <LogContext.Provider value={{ 
      logs, 
      addLog, 
      clearLogs,
      logInfo,
      logError,
      logWarning,
      logSuccess,
      logAI,
      logLayout,
      logPhotos
    }}>
      {children}
    </LogContext.Provider>
  );
};

// Custom hook to use the log context
export const useLogs = () => {
  const context = useContext(LogContext);
  if (!context) {
    throw new Error('useLogs must be used within a LogProvider');
  }
  return context;
};
